export const getUserStatus = () => async (dispatch) => {
  try {
    dispatch({ type: "GET_USER_STATUS", payload: true });
  } catch (error) {
    console.error(error);
  }
};
